import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export async function getCurrentUser(uid) {
  try {
    const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return { id: userSnap.id, ...userSnap.data() };
    }
    return null;
  } catch (error) {
    console.error("Error fetching current user:", error);
    return null;
  }
}

export async function getPages() {
  try {
    const q = query(
      collection(db, "pages"),
      where("enabled", "==", true),
      orderBy("order", "asc")
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((docItem) => ({
      id: docItem.id,
      ...docItem.data(),
    }));
  } catch (error) {
    console.error("Error fetching pages:", error);
    return [];
  }
}

export async function getFolders(pageId) {
  try {
    const q = query(
      collection(db, "folders"),
      where("pageId", "==", pageId),
      where("enabled", "==", true),
      orderBy("order", "asc")
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((docItem) => ({
      id: docItem.id,
      ...docItem.data(),
    }));
  } catch (error) {
    console.error("Error fetching folders:", error);
    return [];
  }
}

export async function getPageItems(pageId) {
  try {
    const q = query(
      collection(db, "pageItems"),
      where("pageId", "==", pageId),
      where("enabled", "==", true),
      orderBy("order", "asc")
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((docItem) => ({
      id: docItem.id,
      ...docItem.data(),
    }));
  } catch (error) {
    console.error("Error fetching page items:", error);
    return [];
  }
}

export function filterVisibleItems(items, userRoles, department) {
  return items.filter((item) => {
    if (item.visibility === "global") {
      return true;
    }

    if (item.visibility === "role") {
      return Array.isArray(item.roles) && Array.isArray(userRoles)
        ? item.roles.some((role) => userRoles.includes(role))
        : false;
    }

    if (item.visibility === "department") {
      return Array.isArray(item.tags) && department
        ? item.tags.includes(department.toLowerCase())
        : false;
    }

    return false;
  });
}

export function groupItemsByFolder(items, folders) {
  const folderMap = folders.reduce((acc, folder) => {
    acc[folder.id] = { ...folder, items: [] };
    return acc;
  }, {});

  const ungrouped = [];

  items.forEach((item) => {
    if (item.folderId && folderMap[item.folderId]) {
      folderMap[item.folderId].items.push(item);
    } else {
      ungrouped.push(item);
    }
  });

  return {
    folders: Object.values(folderMap),
    ungrouped,
  };
}

export async function updateLastLogin(uid) {
  try {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, {
      lastLoginAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error updating last login:", error);
  }
}
